import { render, staticRenderFns } from "./ChargeTiers.vue?vue&type=template&id=f3bff27a&scoped=true"
import script from "./ChargeTiers.vue?vue&type=script&lang=js"
export * from "./ChargeTiers.vue?vue&type=script&lang=js"
import style0 from "./ChargeTiers.vue?vue&type=style&index=0&id=f3bff27a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bff27a",
  null
  
)

export default component.exports